import React, { useEffect } from 'react';

import ReactDOM from 'react-dom/client';

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { PostHogProvider} from '@posthog/react'

import Directory, { Category } from './directory.js';
import LandingPage from './landing.js';
import { DopRedirect, LandscapeRedirect, PageNotFound, RiskReviewRedirect, VCMRedirect } from './util_pages.js';
import FrameworksToC from './frameworks.js';
import { ThesisPages } from './docs.js';

const REACT_APP_PUBLIC_POSTHOG_KEY = 'phc_rqQTqhCerA7U5dBgmvJ8vinc4u0sybDGPjQxKfFG3wK'
const REACT_APP_PUBLIC_POSTHOG_HOST = 'https://us.i.posthog.com'

const root = ReactDOM.createRoot(document.getElementById('root'));

const posthogOptions = {
    api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
    defaults: '2025-05-24',
    capture_exceptions: true,
}

const PageRouter = () => {
    return <Routes>
        <Route path={'/'} element={<LandingPage />} />
        <Route path={'directory'} element={<Directory />} />
        <Route path={'directory/:categoryId'} element={<Category />} />

        <Route path={'frameworks'} element={<FrameworksToC />} />
        <Route path={'frameworks/:frameworkId'} element={<FrameworksToC />} />
        <Route path={'frameworks/:frameworkId/:pageId'} element={<FrameworksToC />} />

        {/* <Route path={'thesis'} element={<ThesisPages />} />
        <Route path={'thesis/:pageId'} element={<ThesisPages />} /> */}


        {/* Redirects for pages that have been removed */}
        <Route path={'data_risk_review'} element={<RiskReviewRedirect />} />
        <Route path={'data_operations_plans*'} element={<DopRedirect />} />
        <Route path={'landscape*'} element={<LandscapeRedirect />} />
        <Route path={'virtual_cell_models*'} element={<VCMRedirect />} />
        {/*  */}

        <Route path={'*'} element={<PageNotFound />} />
    </Routes>
}


const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

root.render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={REACT_APP_PUBLIC_POSTHOG_KEY}
            options={posthogOptions}
        >
            <Router>
                <ScrollToTop />
                <PageRouter />
            </Router>
        </PostHogProvider>
    </React.StrictMode>
);